import { EventDetailHeader } from "@/components/event-detail/event-detail-header";
import { EventDetailTitle } from "@/components/event-detail/event-detail-title";
import { CryptoEventViewModel, CryptoGuess } from "@/event-core/types";
import { MotionValue } from "framer-motion";
import Chart from "./chart";
import { TimeTimeline } from "./time-timeline";

interface CryptoEventOverviewProps {
    event: NonNullable<CryptoEventViewModel["eventData"]>;
    guess: CryptoGuess;
    guessList: CryptoGuess[];
    isSingleGuessDetailPage: boolean;
    isInsetLayout: boolean;
    titleCompactProgress: MotionValue<number>;
    onBack: () => void;
    onGuessChange: ( guess: CryptoGuess ) => void;
    onUpdateGuessList: () => void;
    showVolHeader?: boolean;
}

export function CryptoEventOverview( {
    event,
    guess,
    guessList,
    isSingleGuessDetailPage,
    isInsetLayout,
    titleCompactProgress,
    onBack,
    onGuessChange,
    onUpdateGuessList,
    showVolHeader = true,
}: CryptoEventOverviewProps ) {
    return (
        <>
            {showVolHeader
                ? (
                    <EventDetailHeader
                        isSingleGuessDetailPage={isSingleGuessDetailPage}
                        tradeAmount={Number( event.tradeAmount )}
                        onBack={onBack}
                        eventData={event}
                    />
                )
                : null}

            <EventDetailTitle
                eventImageUrl={event.eventImageUrl}
                eventTitle={event.eventTitle}
                compactProgress={titleCompactProgress}
                isSingleGuessDetailPage={isSingleGuessDetailPage}
                isInset={isInsetLayout}
                endTime={guess.scheduleEndTime}
                eventCategory={event.eventCategory}
            />
            <Chart event={event} guess={guess} guessList={guessList} />
            <TimeTimeline
                guessList={guessList}
                eventData={event}
                onGuessChange={onGuessChange}
                selectedGuess={guess}
                onUpdateGuessList={onUpdateGuessList}
            />
        </>
    );
}
